import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { Register, TreeComponent } from '@xanadu/core';
import { Node, Unit, Role, Branch } from '@xanadu/model';
import { NodeModel } from '@xanadu/model';
import { RoleMenuBuilder } from '@xanadu/menu';

@Component({
    selector: 'app-role-tree',
    templateUrl: './role-tree.component.html',
    styleUrls: ['./role-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('role-tree')
export class RoleTreeComponent extends TreeComponent<Role | Unit> {
    menuBuilder = inject(RoleMenuBuilder);
    menuPosition = { x: 0, y: 0 };

    protected override get nodeType(): string | undefined {
        return 'role';
    }

    onUnit() {
        const unit = new Unit(undefined);
        unit.name = 'new unit';
        this.addChild(unit);
    }

    onRole() {
        const role = new Role(undefined);
        role.name = 'new role';

        this.addChild(role);
    }

    onPaste() {
        this.paste();
    }

    protected replace(node: Node, branch: Branch): Observable<Role | Unit> {
        return this.dataService.replace<Role | Unit>(node as any, branch);
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }
}
